export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white pb-20 md:pb-0">
      <div className="py-12 border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
            <div>
              <div className="mb-4 flex items-center gap-4">
                <img 
                  src="https://static.readdy.ai/image/5f53cefd87e94fc6c03249023a0b95b5/0c8167376927e032ee82e947bbcb1c66.png" 
                  alt="INFORESTA インフォレスタ" 
                  className="h-16 w-auto bg-white p-2 rounded-lg"
                />
                <img 
                  src="https://static.readdy.ai/image/5f53cefd87e94fc6c03249023a0b95b5/cddd3756def19d56959f88c92daf06cb.png" 
                  alt="SCC/INT/250210/9854 ISO/IEC 27001:2022" 
                  className="h-16 w-auto bg-white p-2 rounded-lg"
                />
              </div>
              <p className="text-gray-400 text-sm font-semibold mb-2">株式会社インフォレスタ</p>
              <p className="text-gray-400 text-sm leading-relaxed mb-3">
                〒113-0033<br />
                東京都文京区本郷1-34-1 本郷ビル2F
              </p>
              <a 
                href="https://www.inforesta.com/top/privacy-landing-page/?_gl=1*1bs5gn*_gcl_au*NjE0NzM5NjYxLjE3NjM2ODU5OTA.*_ga*NjU5OTg4MTkzLjE3NjM2ODU5OTA.*_ga_2Y7CSGBBDY*czE3NjM2OTMyOTkkbzIkZzEkdDE3NjM2OTMzMDAkajU5JGwwJGgw" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer block mb-2"
              >
                プライバシーポリシー
              </a>
              <a 
                href="https://www.inforesta.com/top/description/?_gl=1*bkq0i*_gcl_au*NjE0NzM5NjYxLjE3NjM2ODU5OTA.*_ga*NjU5OTg4MTkzLjE3NjM2ODU5OTA.*_ga_2Y7CSGBBDY*czE3NjM2OTMyOTkkbzIkZzEkdDE3NjM2OTMzMDAkajU5JGwwJGgw" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer block"
              >
                特定商取引法に基づく表記
              </a>
            </div>

            <div>
              <h4 className="font-bold mb-4">お問い合わせ</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li className="flex items-center gap-2">
                  <i className="ri-phone-line"></i>
                  <span>03-0000-0000</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-line"></i>
                  <span>月~金(土日祝除く) 9:00~17:30</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-global-line"></i>
                  <a 
                    href="https://www.inforesta.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="hover:text-white transition-colors cursor-pointer"
                  >
                    https://www.inforesta.com
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-400">
            <p>© 2025 株式会社インフォレスタ All Rights Reserved.</p>
            <div className="flex items-center gap-6">
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-white transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}